import { Link, SxProps } from "@mui/material";
import { Parameter } from "../../../common/types/parameters";
import { Column } from "../types";
import ParameterSection from "../parameter-section";
import {
  supplementalDistrictHeatingCostSummarySections,
  supplementalDistrictHeatingInputSections,
} from "./supplemental-district-heating-sections";

const HEAT_TECH_PREFIX = "AirSource";

export default function AirSourceHeatPump(params: {
  description?: string;
  printTitle: string;
  parameters: Parameter[];
  includeVat: boolean;
  toPrint: boolean;
  onValidParameterChange?: (id: string, value: string) => void;
  onSectionChange?: (targetTab: string) => void;
  sx?: SxProps;
}) {
  return (
    <ParameterSection
      printTitle={params.printTitle}
      description={params.description}
      parameters={params.parameters}
      columns={columns(params.onSectionChange)}
      toPrint={params.toPrint}
      includeVat={params.includeVat}
      onValidParameterChange={params.onValidParameterChange}
      sx={params.sx}
    />
  );
}
const columns = (onSectionChange: ((targetTab: string) => void) | undefined) =>
  [
    {
      sections: [
        {
          title: "Årliga kostnader",
          parameters: [
            "AirSourceCapitalCost",
            "AirSourceHeatPumpMaintenanceCost",
            "AirSourceSupplementalDistrictHeatingTotalCostsSum",
            "AirSourceEnergyCost",
            "AirSourceIncreasedGridCost",
          ],
        },
        {
          title: "",
          parameters: ["AirSourceTotalSpecificCost"],
        },
        ...supplementalDistrictHeatingCostSummarySections(HEAT_TECH_PREFIX),
        {
          title: "Beräknade värden för nytt elabonnemang",
          parameters: [
            "AirSourceAndBuildingElectricityLoad",
            "AirSourceFuseDemand",
          ],
        },
      ],
      readOnly: true,
    },
    {
      description: (
        <>
          Prislistor kan justeras på den{" "}
          <Link
            href="#"
            onClick={() => {
              if (onSectionChange !== undefined) {
                onSectionChange("Common");
              }
            }}
          >
            Övergripande
          </Link>{" "}
          fliken.
        </>
      ),
      sections: [
        {
          title: "Detaljerade indata",
          parameters: [
            "AirSourceHeatingDesignLoad",
            "AirSourceHeatPumpLoadCoverage",
            "AirSourceHeatPumpEnergyCoverage",
            "AirSourceHeatPumpDeliveredHeatingLoad",
            "AirSourceRemainingHeatingLoad",
            "AirSourceHeatPumpSCOPRadiator",
            "AirSourceHeatPumpSCOPFloor",
          ],
        },
        {
          title: "Investeringskostnad",
          parameters: [
            "AirSourceEnergyWellCost",
            "AirSourceEnergyWellLifesSpan",
            "AirSourceHeatPumpCost",
            "AirSourceHeatPumpLifeSpan",
            "AirSourceMiscellaneousCost",
            "AirSourceMiscellaneousLifeSpan",
          ],
        },
        {
          title: "Drift- och underhållskostnader",
          parameters: ["AirSourceHeatPumpMaintenanceCost"],
        },
        ...supplementalDistrictHeatingInputSections(HEAT_TECH_PREFIX),
      ],
    },
  ] as Column[];
